import { Image, UIText1 } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './PromosBanner.css';
import promoSvg from './assets/promo.svg';
import { NBSP } from '../../constants/symbols';

export interface IPromosBannerProps {
  isBuilder: boolean;
  contactsButton: React.ReactElement;
}

export const PromosBanner = ({ contactsButton, isBuilder }: IPromosBannerProps) => {
  return (
    <div className={classNames(styles['banner'])} data-testid="promos-banner">
      <div className={styles['image-wrapper']}>
        <Image src={promoSvg} objectFit="contain" height="80px" display="block" />
      </div>
      <div className={styles['text']}>
        <UIText1>
          Позвоните {isBuilder ? 'застройщику' : 'продавцу'}
          {NBSP}—{NBSP}он{NBSP}расскажет, какие скидки и{NBSP}акции могут вам{NBSP}подойти
        </UIText1>
      </div>
      <div className={styles['call-button-wrapper']}>{contactsButton}</div>
    </div>
  );
};
